import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpApi from "i18next-http-backend";

i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: ["ar", "fr", "en"],
    fallbackLng: "ar",

    ns: ["translation"],
    defaultNS: "translation",

    backend: {
      loadPath: "/locales/{{lng}}/translation.json",
    },

    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "darssy_lang",
    },

    interpolation: { escapeValue: false },
    react: { useSuspense: false },
  });

function applyDocumentDirection(lng) {
  if (typeof document === "undefined") return;

  const resolvedLang = lng || i18n.resolvedLanguage || i18n.language || "ar";
  const dir = i18n.dir(resolvedLang);

  document.documentElement.setAttribute("lang", resolvedLang);
  // Keep browser chrome behavior (including scrollbar side) stable.
  document.documentElement.setAttribute("dir", "ltr");
  document.body.setAttribute("dir", "ltr");

  // Expose app language direction without affecting scrollbar placement.
  document.body.setAttribute("data-i18n-dir", dir);
  const appRoot = document.getElementById("root");
  if (appRoot) appRoot.setAttribute("dir", dir);
}

applyDocumentDirection(i18n.resolvedLanguage || i18n.language);
i18n.on("languageChanged", applyDocumentDirection);

export default i18n;
